import { render, staticRenderFns } from "./NotTodaysPuzzle.vue?vue&type=template&id=1f024752&scoped=true&"
import script from "./NotTodaysPuzzle.vue?vue&type=script&lang=js&"
export * from "./NotTodaysPuzzle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f024752",
  null
  
)

export default component.exports